import styled from '@emotion/styled'

/* Card is always full width, so the half-row layout stays on this wrapper. */
export const AmountCard = styled.div`
  width: 50%;
`
